<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
            <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input clearable disabled v-model="form.name" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="tel">
              <el-input clearable disabled v-model="form.tel" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
            <el-col :span="24">
              <el-form-item label="主要症状" prop="mainSymptoms">
                <el-input clearable placeholder="请输入主要症状"  v-model="form.mainSymptoms" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="处理" prop="handle">
                <el-input clearable  placeholder="请输入处理" v-model="form.handle" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item label="就诊日期" prop="visitDate">
                <el-date-picker
                  v-model="form.visitDate"
                  style="width: 100%;"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择就诊日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出诊医师" prop="visitDoctor">
                <el-input clearable  placeholder="请输入出诊医师" v-model="form.visitDoctor" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="医疗费用" prop="medicalFee">
                <money-input
                 v-model="form.medicalFee"
                templateName="元"
                template="append"
                style="width: 100%"
              />
            
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="text-align: right" v-if="model != 'view'">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
          {{ model == 'add' ? '提交' : '修改' }}
        </el-button>
        <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
      </div>
    </div>
  </template>
  <script>
  import { getProjectList } from '@/api/crmedical/project/project';
  import { getDictionary } from '@/api/common.js';
  import { saveHealthVisit,updateHealthVisit } from '@/api/nursingHome/healthData.js';
  export default {
    components: {},
    props: {
      row: {
        default: {},
      },
      personData: {
        default: {},
      },
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        projectList: [],
        provideList: [],
        form: {
        
          downWarnValue: '',
          upWarnValue: '',
          releaseMode: '',
        },
        formRules: {
          mainSymptoms: [{ required: true, message: '主要症状不能为空', trigger: 'blur' }],
          handle: [{ required: true, message: '处理不能为空', trigger: 'blur' }],
          medicalFee: [{ required: true, message: '医疗费用不能为空', trigger: 'blur' }],
          visitDate: [{ required: true, message: '就诊日期不能为空', trigger: 'change' }],
          visitDoctor: [{ required: true, message: '出诊医师	不能为空', trigger: 'blur' }]
        },
       
        
        paymentTypeList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
      
      async initData() {
        if(this.model != 'add') {
        this.form = Object.assign({},this.row)   
        }
        console.log("person",this.personData)
        this.form.name = this.personData.name
        this.form.elderlyId= this.personData.id
        this.form.nursinghomeId= this.personData.nursinghomeId
        this.form.tel= this.personData.tel
      },
      saveRecord() {
        if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveHealthVisit(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateHealthVisit(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
  